import { render } from "./studioLog.vue?vue&type=template&id=abd0c22e&scoped=true"
import script from "./studioLog.vue?vue&type=script&lang=js"
export * from "./studioLog.vue?vue&type=script&lang=js"

import "./studioLog.vue?vue&type=style&index=0&id=abd0c22e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abd0c22e"]])

export default __exports__